import { Helmet } from 'react-helmet-async';
import React from 'react';
import OrgCustomChangeImpactTypesFormContainer from '../../../../containers/organizations/Settings/OrgCustomChangeImpactTypesFormContainer.jsx';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const CustomStatusesSettings = ({ slug, projectId }) => (
  <>
    <Helmet>
      <title>Change Strategy Settings | ChangeSync</title>
    </Helmet>
    <OrgCustomChangeImpactTypesFormContainer
      slug={slug}
      projectId={projectId}
    />
  </>
);

CustomStatusesSettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(CustomStatusesSettings));
